
	import Vue from "vue";

	export default Vue.extend({
		name: "DropdownField",
		props: {
			disabled: {
				type: Boolean,
				default: false,
			},
			label: {
				type: String,
				default: "",
			},
			options: {
				type: Array,
				default: () => {
					return [];
				},
			},
      required: {
        type: Boolean,
        default: false,
      },
      extraValidations: {
        type: Boolean,
        default: false,
      },
      validation: {
        type: String,
        default: ""
      },
      score: {
        type: Boolean,
        default: false,
      },
      scores: {
        type: Array,
        default: () => {
          return [];
        },
      },
      value: {
        type: String,
        default: null,
      },
		},
		data() {
			return {
				list: this.value,
			};
		},
		methods: {
			updateValue(value: any) {
				this.$emit("input", value);
			},
		},
		watch: {
      value: function (value) {
        this.list = value;
      },
			list: function (nList) {
				this.list = nList;
				this.$emit("input", nList);
			},
		},
	});
